import {
  getWebInstrumentations,
  initializeFaro,
  LogLevel
} from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { escapeRegExp } from 'lodash';

let initialized = false;

function getFaroUrl(): string {
  return import.meta.env.VITE_FARO_URL || '';
}

export function initFaro(appName: string, tracedApiUrls: string[]): void {
  const url = getFaroUrl();
  if (!url || initialized) {
    return;
  }
  initialized = true;

  try {
    initializeFaro({
      url,
      app: { name: appName, environment: window.location.hostname },
      trackResources: false,
      consoleInstrumentation: {
        disabledLevels: [
          LogLevel.DEBUG,
          LogLevel.TRACE,
          LogLevel.LOG,
          LogLevel.INFO,
          LogLevel.WARN
        ]
      },
      instrumentations: [
        ...getWebInstrumentations({ captureConsole: true }),
        new TracingInstrumentation({
          instrumentationOptions: {
            propagateTraceHeaderCorsUrls: tracedApiUrls
              .filter(Boolean)
              .map(apiUrl => new RegExp(`^${escapeRegExp(apiUrl)}`))
          }
        })
      ]
    });
  } catch (error) {
    console.error('Faro initialization failed', error);
  }
}
